<template>
    <div class="relation590">
        <a :style="{ width: meetingButton[0].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[0])">
            <img :src="meetingButton[0].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[0].name }}</p>
        </a>
        <a :style="{ width: meetingButton[2].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[2])">
            <img :src="meetingButton[2].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[2].name }}</p>
        </a>
        <a :style="{ width: meetingButton[1].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[1])">
            <img :src="meetingButton[1].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[1].name }}</p>
        </a>
      
        <a :style="{ width: meetingButton[3].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[3])">
            <img :src="meetingButton[3].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[3].name }}</p>
        </a>
        <div class="col" :style="{ width: meetingButton[4].icon_type != 2 ? '33.3%' : '66.6%' }">
            <!-- <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                <img :src="meetingButton[4].icon" alt="">
                <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[4].name }}</p>
            </a> -->
            <div class="row">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                    <img :src="meetingButton[5].icon" alt="">
                    <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[5].name }}</p>
                </a>
                <a :style="{ width: meetingButton[8].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
                    title="picname" @click="skipLink(meetingButton[8])">
                    <img :src="meetingButton[8].icon" alt="">
                    <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[8].name }}</p>
                </a>
            </div>
            <div class="row">
               
                <a :style="{ width: meetingButton[7].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
                    title="picname" @click="skipLink(meetingButton[7])">
                    <img :src="meetingButton[7].icon" alt="">
                    <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[7].name }}</p>
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img :src="meetingButton[6].icon" alt="">
                    <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[6].name }}</p>
                </a>
            </div>
        </div>
        <!-- <a :style="{ width: meetingButton[7].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[7])">
            <img :src="meetingButton[7].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[7].name }}</p>
        </a>
        <a :style="{ width: meetingButton[8].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[8])">
            <img :src="meetingButton[8].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[8].name }}</p>
        </a> -->
        <!-- <a :style="{ width: meetingButton[9].icon_type != 2 ? '33.3%' : '66.6%' }" href="Javascript:void(0)"
            title="picname" @click="skipLink(meetingButton[9])">
            <img :src="meetingButton[9].icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ meetingButton[9].name }}</p>
        </a> -->
        <!-- <a :style="{ width: button_rows == 4 && item.icon_type != 2 ? '25%' : (button_rows == 4 && item.icon_type == 2) ? '50%' : (button_rows == 3 && item.icon_type != 2) ? '33.3%' : '66.6%' }"
            href="Javascript:void(0)" v-for="(item, index) in meetingButton" :key="index" title="picname"
            :class="item.id == 2101 ? 'sp_btn' : ''" @click="skipLink(item)">
            <img  :src="item.icon" alt="">
            <p style="color:black;font-size:0.4rem;" v-if="showButtonText">{{ item.name }}</p>
        </a> -->
    </div>
</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation590 {
    overflow: auto;
    padding: .3rem .7rem 4rem !important;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;

    div {
        text-align: center;
    }

    a {
        box-sizing: border-box;
        text-align: center;
        // padding: .06rem .06rem;
        margin-bottom: 0;
        width: 100%;
    }

    .col {
        display: flex;
        flex-direction: column;

        a {
            width: 100%;
        }
    }

    .row {
        display: flex;

        a {
            flex: 1;
        }
    }

    img {
        // background: white;	
        border-radius: .5rem;
        width: 100%;
        height: 100%;

    }
}

@media screen and (min-width: 500px) {
    .relation590 {
        padding-bottom: 6rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button590.vue